export default [
  { label: 'userDefined', value: 'userDefined' },
  { label: 'componentPassThrough', value: 'componentPassThrough' },
];
